"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChatDisabled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5.75019891,5.01544864 L6.472,5.99995562 L6,6 C5.48716416,6 5.06449284,6.38604019 5.00672773,6.88337887 L5,7 L5,15 C5,15.5128358 5.38604019,15.9355072 5.88337887,15.9932723 L6,16 L8,16 L8,18.9193752 L11.6492189,16 L13.806,15.9999556 L14.539,16.9999556 L12,17 L8.62469505,19.700244 C8.19343311,20.0452535 7.56414074,19.9753321 7.21913119,19.5440702 C7.07728075,19.3667572 7,19.1464466 7,18.9193752 L7,17 L6,17 C4.8954305,17 4,16.1045695 4,15 L4,7 C4,5.98002704 4.76352472,5.13838484 5.75019891,5.01544864 Z M6.84355718,3.13660584 L6.9032025,3.20431817 L17.9032025,18.2043182 C18.0665031,18.4270008 18.0183644,18.7399019 17.7956818,18.9032025 C17.5977418,19.0483586 17.3285179,19.0264515 17.1564428,18.8633942 L17.0967975,18.7956818 L6.0967975,3.79568183 C5.93349694,3.57299924 5.98163558,3.26009807 6.20431817,3.0967975 C6.40225825,2.95164144 6.67148215,2.97354846 6.84355718,3.13660584 Z M9.46,4.99995562 L18,4.99995562 C19.1045695,4.99995562 20,5.8954305 20,7 L20,15 C20,16.0203168 19.2359603,16.8621827 18.248803,16.9846755 L17.527,15.9999556 L18,16 C18.5128358,16 18.9355072,15.6139598 18.9932723,15.1166211 L19,15 L19,7 C19,6.48716416 18.6139598,6.06449284 18.1166211,6.00672773 L18,6 L10.193,5.99995562 L9.46,4.99995562 Z" })));
};
ChatDisabled.displayName = 'ChatDisabled';
exports.default = ChatDisabled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatDisabled.js.map